"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var icon_1 = __importDefault(require("../../icon"));
var BannerTabItem_1 = __importDefault(require("./BannerTabItem"));
function TabPc(props) {
    var _a = props || {}, tabTitle = _a.tabTitle, tabList = _a.tabList;
    var _b = (0, react_1.useState)(false), tabActive = _b[0], setTabActive = _b[1];
    var toggleActive = function (e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setTabActive(!tabActive);
    };
    var handleCancel = function () {
        setTabActive(false);
    };
    (0, react_1.useEffect)(function () {
        window.addEventListener('click', handleCancel);
        return function () {
            window.removeEventListener('click', handleCancel);
        };
    }, []);
    // tab pc item
    function renderTabItemPC(item, index) {
        return react_1.default.createElement(BannerTabItem_1.default, __assign({ key: "tab-".concat(index) }, item));
    }
    return (react_1.default.createElement("div", { className: "tab-pc" },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('tab-dropdown', {
                active: tabActive,
            }), onClick: function (e) { return toggleActive(e); } },
            react_1.default.createElement("div", { className: "tab-pc-title" }, tabTitle),
            react_1.default.createElement(icon_1.default, { name: "arrow-down", size: 24, color: tabActive ? '#006eff' : '#000000', className: "active-icon" }),
            react_1.default.createElement("div", { className: "tab-dropdown-btn-menu" }, tabList.map(renderTabItemPC)))));
}
exports.default = TabPc;
//# sourceMappingURL=TabPc.js.map